import { render, staticRenderFns } from "./SubCategoryForm.vue?vue&type=template&id=dc9e0420&scoped=true&"
import script from "./SubCategoryForm.vue?vue&type=script&lang=js&"
export * from "./SubCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryForm.vue?vue&type=style&index=0&id=dc9e0420&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9e0420",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
